/**
 * @file mappers.js
 * @location src/integrations/supabase/mappers.js
 * @role DB row(snake_case) ↔ 도메인 모델(camelCase) 변환. 경계 1곳에 격리.
 *
 * 도메인 타입은 src/data/types.js (Task / Member / TaskTemplate).
 * undefined 생략 정책: 폐기 razor 잔재 없이 기존 reducer/셀렉터와 동일한 형태 유지.
 */
import { normalizeRefs } from '../../utils/refs.js';

/** tasks row → Task */
export function rowToTask(r) {
  const t = {
    id: r.id,
    createdAt: r.created_at,
    title: r.title,
    status: r.status,
    priority: r.priority,
    aee: r.aee,
    aor: r.aor,
    // null=안 읽음 / set=읽음. reducer 가 truthiness 로 분기하므로 null 유지
    acknowledgedAt: r.acknowledged_at ?? null,
  };
  if (r.due)             t.due = r.due;
  if (r.date_kind)       t.dateKind = r.date_kind;
  if (r.note)            t.note = r.note;
  if (r.completed_at)    t.completedAt = r.completed_at;
  if (r.cancelled_at)    t.cancelledAt = r.cancelled_at;
  if (r.cancel_reason)   t.cancelReason = r.cancel_reason;
  if (r.deleted_at)      t.deletedAt = r.deleted_at;
  if (r.template_id)     t.templateId = r.template_id;
  if (r.occurrence_date) t.occurrenceDate = r.occurrence_date;
  if (Array.isArray(r.refs) && r.refs.length) t.refs = normalizeRefs(r.refs);
  return t;
}

/** members row → Member (pending = invite_code 있는 미수락 자리) */
export function rowToMember(r) {
  const m = {
    id: r.id,
    name: r.name ?? '',
    email: r.email ?? '',
    mainCases: r.main_cases ?? [],
  };
  if (r.is_manager) m.isManager = true;
  if (r.invite_code) m.pending = { code: r.invite_code, invitedAt: r.invited_at };
  return m;
}

/** task_templates row → TaskTemplate */
export function rowToTemplate(r) {
  return {
    id: r.id,
    createdAt: r.created_at,
    title: r.title,
    aees: r.aees ?? [],
    repeat: r.repeat,
    active: r.active,
    lastGenDate: r.last_gen_date ?? null,
  };
}
